import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, fileUrl } from '../lib/api';

export default function EmbedPage() {
    const { videoId } = useParams();
    const [video, setVideo] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        api.get(`/videos/${videoId}`)
            .then((response) => setVideo(response.data))
            .catch((requestError) => setError(requestError.response?.data?.detail || 'No s’ha pogut carregar el vídeo'));
    }, [videoId]);

    if (error) return <main className="grid min-h-screen place-items-center bg-black p-6 text-center text-white"><p>{error}</p></main>;
    if (!video) return <main className="grid min-h-screen place-items-center bg-black text-white/70"><p>Carregant vídeo...</p></main>;

    const item = video.video;
    if (item.is_premium && !video.can_watch) {
        return <main className="grid min-h-screen place-items-center bg-black p-6 text-center text-white"><p>Aquest vídeo és premium i requereix accés.</p></main>;
    }

    return (
        <main className="min-h-screen bg-black text-white">
            <div className="group relative">
                <video className="block aspect-video h-auto max-h-screen w-full object-contain" src={fileUrl(item.video_url)} poster={item.thumbnail_url ? fileUrl(item.thumbnail_url) : undefined} controls loop playsInline preload="metadata" />
                <a href="https://albambam.com/" target="_blank" rel="noreferrer" aria-label="Albambam" className="absolute bottom-14 right-3 flex items-center gap-1.5 rounded-md bg-black/60 px-2 py-1 opacity-80 backdrop-blur transition-opacity hover:opacity-100">
                    <img src="https://albambam.com/logo.jpg" alt="" className="h-5 w-5 rounded object-cover" />
                    <span className="text-[11px] font-semibold text-white">Albambam</span>
                </a>
            </div>
            <div className="flex items-center justify-between gap-3 px-4 py-3">
                <div className="min-w-0"><h1 className="truncate text-sm font-semibold">{item.title}</h1><p className="truncate text-xs text-white/60">{item.uploader_name}</p></div>
                <a href={`https://albambam.com/video/${videoId}`} target="_blank" rel="noreferrer" className="shrink-0 text-xs text-amber-300 hover:underline">Veure a Albambam</a>
            </div>
        </main>
    );
}
